import { render, staticRenderFns } from "./ProjectEditView.vue?vue&type=template&id=6aa51a50&scoped=true"
import script from "./ProjectEditView.vue?vue&type=script&lang=ts"
export * from "./ProjectEditView.vue?vue&type=script&lang=ts"
import style0 from "./ProjectEditView.vue?vue&type=style&index=0&id=6aa51a50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa51a50",
  null
  
)

export default component.exports